import styled from 'styled-components'
import Radio from '@material-ui/core/Radio'

export const RadioStyle = styled(Radio).attrs({
  color: 'default',
})`
  width: 48px;
  height: 48px;
`
